export default __webpack_public_path__ + "static/media/navigate_next-green.fceb2bf8.svg";